/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The scope level at which a streak operates
 * @export
 */
export const StreakScope = {
    PLATFORM: 'PLATFORM',
    HUB: 'HUB',
    BRAND: 'BRAND',
    COMPETITION: 'COMPETITION'
} as const;
export type StreakScope = typeof StreakScope[keyof typeof StreakScope];


export function instanceOfStreakScope(value: any): boolean {
    for (const key in StreakScope) {
        if (Object.prototype.hasOwnProperty.call(StreakScope, key)) {
            if (StreakScope[key as keyof typeof StreakScope] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakScopeFromJSON(json: any): StreakScope {
    return StreakScopeFromJSONTyped(json, false);
}

export function StreakScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakScope {
    return json as StreakScope;
}

export function StreakScopeToJSON(value?: StreakScope | null): any {
    return value as any;
}

export function StreakScopeToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakScope {
    return value as StreakScope;
}

